namespace RioERP.Masters {
    export interface InvoiceCompanyRow {
        Id?: number;
        TaxApplicable?: Web.Enums.TaxApplicable;
        Name?: string;
        Address?: string;
        GstIn?: string;
        InvoiceCode?: string;
        IsTaxApplicable?: boolean;
        InvoiceChangeDate?: string;
        IsDefault?: boolean;
        DisableInvoiceGenration?: boolean;
        FooterNote?: string;
        Logo1?: string;
        Logo2?: string;
        StampImage?: string;
    }

    export namespace InvoiceCompanyRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Masters.InvoiceCompany';
        export const lookupKey = 'Masters.InvoiceCompany';

        export function getLookup(): Q.Lookup<InvoiceCompanyRow> {
            return Q.getLookup<InvoiceCompanyRow>('Masters.InvoiceCompany');
        }
        export const deletePermission = 'Masters:MastersManagement:Modify';
        export const insertPermission = 'Masters:MastersManagement:Modify';
        export const readPermission = 'Masters:MastersManagement:View';
        export const updatePermission = 'Masters:MastersManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            TaxApplicable = "TaxApplicable",
            Name = "Name",
            Address = "Address",
            GstIn = "GstIn",
            InvoiceCode = "InvoiceCode",
            IsTaxApplicable = "IsTaxApplicable",
            InvoiceChangeDate = "InvoiceChangeDate",
            IsDefault = "IsDefault",
            DisableInvoiceGenration = "DisableInvoiceGenration",
            FooterNote = "FooterNote",
            Logo1 = "Logo1",
            Logo2 = "Logo2",
            StampImage = "StampImage"
        }
    }
}
